import React from 'react';
import { useLocation } from 'react-router';
import {
  ForgeScaffold,
} from '@tylertech/forge-react';
import GeneralErrorPage from '../reusable/ErrorPages/GeneralErrorPage.js';
import { getErrorPagesByType } from '../reusable/ErrorPages/errorPagesHelpers.js';
import { SSO_PROVIDER_TYLER } from '../../static/keyWords.js';

const EmailMismatchStep = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const ssoProvider = params.get('ssoProvider');
  // Support mismatch links produced by the previous backend during deployment.
  const isTylerProvider = ssoProvider
    ? ssoProvider === SSO_PROVIDER_TYLER
    : params.get('ssoLogin') === 'true';

  const endSession = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.href = isTylerProvider
      ? process.env.REACT_APP_END_GATEWAY_SSO_SESSION_URL
      : process.env.REACT_APP_END_SSO_SESSION_URL;
  };

  return (
    <ForgeScaffold className="emailMismatchScaffold">
      <main slot="body" className="emailMismatchPage">
        <GeneralErrorPage type={getErrorPagesByType(null, endSession).EMAIL_MISMATCH} />
      </main>
    </ForgeScaffold>
  );
};

export default EmailMismatchStep;
